var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons for Input"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.06598 9.56001L11.1627 6.46331C11.257 6.36622 11.3856 6.30998 11.521 6.30678C11.625 6.30433 11.7274 6.33337 11.8147 6.3901L11.6784 6.5997L11.8147 6.3901C11.9019 6.44683 11.97 6.52861 12.01 6.6247C12.05 6.7208 12.06 6.82674 12.0387 6.92863C12.0177 7.02953 11.9669 7.12181 11.893 7.19358L8.06598 9.56001ZM8.06598 9.56001L4.96887 6.46289C4.92104 6.41404 4.86398 6.37517 4.801 6.34854C4.73736 6.32163 4.66897 6.30776 4.59988 6.30776L4.59981 6.30776C4.49704 6.30778 4.39662 6.33847 4.31138 6.39589C4.22615 6.45331 4.15999 6.53485 4.12136 6.63008C4.08274 6.72531 4.0734 6.8299 4.09455 6.93047C4.11555 7.03035 4.16568 7.12175 4.23858 7.19315L8.06598 9.56001Z",
    fill: "#6C737F",
    stroke: "#6C737F",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectArrow);
export default __webpack_public_path__ + "static/media/SelectArrow.3d31ed994e4fa9b0671142c3df8c0753.svg";
export { ForwardRef as ReactComponent };